/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminTeam,
  AdminV1OrganizationsTeamsListParams,
  PaginatedAdminTeamList,
  PatchedAdminTeam
} from '.././model';

import adminV1OrganizationsTeamsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsTeamsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsTeamsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsTeamsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsTeamsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsTeamsDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsList = (
    organizationId: number,
    params?: AdminV1OrganizationsTeamsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsListMutator<PaginatedAdminTeamList>>,) => {
      return adminV1OrganizationsTeamsListMutator<PaginatedAdminTeamList>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsCreate = (
    organizationId: number,
    adminTeam: NonReadonly<AdminTeam>,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsCreateMutator<AdminTeam>>,) => {
      return adminV1OrganizationsTeamsCreateMutator<AdminTeam>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminTeam
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsRetrieveMutator<AdminTeam>>,) => {
      return adminV1OrganizationsTeamsRetrieveMutator<AdminTeam>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsUpdate = (
    organizationId: number,
    id: number,
    adminTeam: NonReadonly<AdminTeam>,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsUpdateMutator<AdminTeam>>,) => {
      return adminV1OrganizationsTeamsUpdateMutator<AdminTeam>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminTeam
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminTeam: NonReadonly<PatchedAdminTeam>,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsPartialUpdateMutator<AdminTeam>>,) => {
      return adminV1OrganizationsTeamsPartialUpdateMutator<AdminTeam>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminTeam
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsTeamsDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsTeamsDestroyMutator<void>>,) => {
      return adminV1OrganizationsTeamsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/teams/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsTeamsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsList>>>
export type AdminV1OrganizationsTeamsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsCreate>>>
export type AdminV1OrganizationsTeamsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsRetrieve>>>
export type AdminV1OrganizationsTeamsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsUpdate>>>
export type AdminV1OrganizationsTeamsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsPartialUpdate>>>
export type AdminV1OrganizationsTeamsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsTeamsDestroy>>>
